import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';

@Component({
  selector: 'app-upload-file',
  templateUrl: './app-upload-file.component.html',
  styleUrls: ['./app-upload-file.component.scss']
})
export class AppUploadFileComponent implements OnInit {
  @Input() acceptedFileTypes!: string;
  @Input() labelName!: string;
  @Input() maxFileSize: number = 10 * 1024 * 1024;
  @Output() selectedFile: EventEmitter<File[]> = new EventEmitter<File[]>();

  constructor(private toastr: ToastrService){}

  ngOnInit(): void {

  }

  onFileSelected(event: any) {
    const fileInput = event.target;
    
    if (fileInput.files && fileInput.files.length > 0) {

      let documents:File[]= [];

      for (let i = 0; i < fileInput.files.length; i++) {
        if (fileInput.files[i].size <= this.maxFileSize) {
          documents.push(fileInput.files[i]);
        }
        else {
          showNotification(
                  'danger',
                  `Max file size is ${this.maxFileSize / 1024 / 1024} MB.`,
                  this.toastr
                );
        }
      }

      this.selectedFile.emit(documents);
    }

    fileInput.value =''; // This clears the file input
  }


}